<template>
  <b-button size="sm"
            :class="{
              'zoom-button': true,
              'is-selected': isSelected,
              'is-pyramid-level': shouldHighlightPyramid && isPyramidLevel,
              'is-digital': isDigital
            }"
            :title="isDigital ? $t('digital-hover') : ''"
            :style="style"
            @click="$emit('click')"
  >
    {{ label }}
  </b-button>
</template>

<script>
  import us from '../../defines';
  import { renderSettings } from '../../render-settings';

  export default {
    name: 'ZoomButton',
    i18nOptions: { keyPrefix: 'uScope.extensions.zoom' },
    props: {
      mag: {
        type: Number,
        required: true
      },
      baseMag: {
        type: Number,
        required: true
      },
      isSelected: {
        type: Boolean,
        default: false
      },
      isPyramidLevel: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      style () {
        return `border-left-color: ${us.objectiveColor(this.mag)}`;
      },
      isDigital () {
        return this.mag > this.baseMag;
      },
      label () {
        return this.isDigital ? this.$t('digital-label', { multiplier: this.mag / this.baseMag }) : `${this.mag}x`;
      },
      shouldHighlightPyramid () {
        return renderSettings.highlightPyramidLevels;
      }
    }
  };
</script>

<style scoped lang="scss">
@import './zoom-button';
</style>



// WEBPACK FOOTER //
// src/uScope/js/extensions/zoom/ZoomButton.vue